import { render, staticRenderFns } from "./Elszam.vue?vue&type=template&id=38406f62&lang=html&"
import script from "./Elszam.vue?vue&type=script&lang=js&"
export * from "./Elszam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports